import React, { useEffect, useState } from "react";
import { Typography, Row, Col, Card, Button, Collapse, Switch, InputNumber } from "antd";
import {
  CheckOutlined,
  TagFilled,
  FireOutlined,
  UpOutlined,
  DownOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import { plans, bundles, VIEW_MODAL_DICT } from "../../data/data";
import "./Plans.scss";
import WhatYouGet from "../WhatYouGet/WhatYouGet";
import "../../../../../../styles/helper.scss"
import { PORTAL_LINK } from "../../../../../../environments/env";

const allowedKeys = [
  'Backspace',
  'Delete',
  'ArrowLeft',
  'ArrowRight',
];
const { Paragraph } = Typography;

const SubscriptionSelector = ({ selectedPlan, setSelectedPlan, annual, setAnnual, setAnnualSetting }) => {

  return (
    <div className={`subscription-selector-wrapper ${selectedPlan === "subscriptions" ? "justify-space-between" : "justify-in-center"}`}>
      {selectedPlan === "subscriptions" &&
        <div style={{ width: 250 }} className="hide-web-version">
        </div>}
      <div className="subscription-selector">
        <div
          className={`plan ${selectedPlan === "bundles" ? "selected" : ""}`}
          onClick={() => setSelectedPlan("bundles")}>
          <span className="plan-title manrope f-14 w-700">Buy a bundle</span>
        </div>
        <div
          className={`plan ${selectedPlan === "subscriptions" ? "selected" : ""
            }`}
          onClick={() => setSelectedPlan("subscriptions")}>
          <span className="plan-title manrope f-14 w-700">Subscribe & Save</span>
        </div>
      </div>

      {selectedPlan === "subscriptions" &&
        <div className="switch-wrapper">
          <span className={`manrope f-12 lh-20 black-085 ${annual ? 'w-500' : 'w-700'} mr-8`}>Monthly</span>
          <Switch
            className='silo-compare-switch'
            checked={annual}
            onChange={(checked) => {
              setAnnual(checked);
              setAnnualSetting(checked);
            }} />
          <span className={`manrope f-12 lh-20 black-085 ${annual ? 'w-700' : 'w-500'} ml-8`}>Annually</span>
          <div className={`ml-8 save-discount-bg ${annual ? 'blue' : 'gray'}`}>
            <span className={`manrope f-12 lh-20 ${annual ? 'w-700 blue' : 'w-500 black-085'}`}>Save 17%</span>
          </div>
        </div>}
    </div>
  );
};

const FeatureList = ({ features }) => (
  <ul>
    {features.map((feature, i) => (
      <li key={i} className="justify-space-between">
        <div className="justify-in-start-align-baseline">
          <span className="feature-icon">
            <CheckOutlined />
          </span>
          <span className="manrope f-14 black-085 lh-22">{feature}</span>
        </div>
      </li>
    ))}
  </ul>
);

const PlanCard = ({ plan,
  index, 
  openPaymentConfirmationModal,
  currentlyActiveSubscription,
  annual }) => {

  const renderFeatures = <FeatureList features={annual ? plan.features : plan.monthly_features} />;

  return (
    <Col xs={24} sm={12} md={12} lg={6} key={index} className={`halo-outline transparent`}>
      <Card className="plan-card" bordered={false}>
        <div className="card-content">
          <span className="card-subtitle manrope f-14 w-500">{plan.subtitle}</span>
          <span className="card-title manrope f-20 w-700">{plan.title}</span>
          <Paragraph className="card-description manrope f-14 w-500 lh-22">
            {plan.description}
            {plan.discount_monthly && annual == false ? (
              <div className="discount-wrapper">
                <TagFilled className="discount-icon" />
                <Paragraph className="discount manrope f-12 w-500">{plan.discount_monthly}</Paragraph>
              </div>
            ) : plan.discount && annual && (
              <div className="discount-wrapper">
                <TagFilled className="discount-icon" />
                <Paragraph className="discount manrope f-12 w-500">{plan.discount}</Paragraph>
              </div>
            )}
          </Paragraph>
          <div className={`card-price manrope f-24 w-700 a-baseline ${["Pro", "Starter", "Growth"].includes(plan.package_type) ? "mt-0" : ""}`}>
            {annual == false && plan.package_type != 'Enterprise' ? '$' + plan.priceMonthly : (plan.package_type == 'Enterprise' ? '' : '$') + plan.price}
            <div className="annual-period">{plan.annualPeriod}</div>
          </div>
          <Paragraph className="monthly-period manrope f-14 w-400">{annual == false ? plan.monthlyPlusPeriod : plan.monthlyPeriod}</Paragraph>
          <Button
            type="primary"
            className={`card-button`}
            block
            onClick={() => {
              if (plan.plan_name != 'enterprise')
                openPaymentConfirmationModal(plan.plan_name, 'subscription')
              else
                window.location.href = `${PORTAL_LINK}contact-us`
            }}
          >
            {
              plan.package_type == 'Enterprise'
                ? plan.buttonText
                :
                  (plan.plan_name == currentlyActiveSubscription || plan.annual_plan_name == currentlyActiveSubscription
                    ? 'Renew Subscription'
                    : `Switch to ${plan.package_type}`)
            }
          </Button>

          <div className="justify-space-between mt-17">
            {annual ?
              <div className="manrope f-12 w-500 black-085">{plan.get_more_text}</div> :
              <div className="manrope f-12 w-500 black-085">{plan.package_type == 'Enterprise' ? plan.get_more_text : plan.get_more_text_monthly}</div>}
          </div>
        </div>


        <div className="features-wrapper">
          {/* Desktop view */}
          <div className="desktop-features md:block">
            <>
              <span className="features-heading manrope f-14 w-700">Includes</span>
              <div className="features manrope f-14 w-500">{renderFeatures}</div>

              <span className="features-heading manrope f-14 w-700">Plus</span>
              <div className="features manrope f-14 w-500"><FeatureList features={plan.plus_features} /> </div>

            </>
          </div>
        </div>

      </Card>
    </Col>
  );
};

const BundleCard = ({ bundle, index, openPaymentConfirmationModal }) => {
  const [quantity, setQuantity] = useState({
    "Basic Bundle": 5,
    "Studio Bundle": 45,
    "ALL3D Enterprise": 1,
});

const [minQuantity, setMinQuantity] = useState({
    "Basic Bundle": 5,
    "Studio Bundle": 45,
    "ALL3D Enterprise": 1,
});

  useEffect(() => {
    setMinQuantity((prev) => ({
      ...prev,
      [bundle.title]: bundle.min_quantity,
    }));
    setQuantity((prev) => ({
      ...prev,
      [bundle.title]: bundle.min_quantity,
    }));
  }, []);


  const handleQuantityChange = (value, packageType) => {
    setQuantity((prev) => ({
      ...prev,
      [packageType]: value,
    }));
  };

  const renderFeatures = <FeatureList features={bundle.features} />;
  const renderMobileFeatures = (
    <Collapse
      expandIconPosition="right"
      expandIcon={({ isActive }) =>
        isActive ? <UpOutlined /> : <DownOutlined />
      }
    >
      <Collapse.Panel header={"Includes"} key="1">
        <div className="features">{renderFeatures}</div>
      </Collapse.Panel>
    </Collapse>
  );


  return (
    <Card className="plan-card">
      <div className="card-content">
      <span className="card-subtitle manrope f-14 w-500">{bundle.subtitle}</span>

        <span className="card-title bundle manrope f-20 w-700 black-085">{bundle.title}</span>
        <Paragraph className="card-description bundle manrope f-14 w-500 black-085 lh-22">
          {bundle.description}
        </Paragraph>
        <div className="justify-space-between align-baseline wrap-flex">
          <div>
            {bundle.price == 0 ? <span className="card-price manrope f-26 black-085 w-700 a-baseline">
              Let's talk
            </span>
              :
              <span className="card-price manrope f-26 black-085 w-700 a-baseline">
                ${bundle.price}
                <span className="annual-period manrope f-14 w-400 black-085 lh-22">/image</span>
              </span>}
          </div>
          {bundle.price == 0 ? '' :
            <div className="justify-in-end">
              <div className="manrope f-10 lh-22 black-085 w-500 mr-8">QTY</div>
              <InputNumber min={minQuantity[bundle.title] || 1}
                value={quantity[bundle.title] || 1}
                onKeyDown={(e) => {
                  if ((["-", ".", " "].includes(e.key)) || (/[a-zA-Z\s]/.test(e.key) && !allowedKeys.includes(e.key))) {
                    e.preventDefault();
                  }
                }}
                onChange={(value) => handleQuantityChange(value, bundle.title)}
                className="manrope f-14 lh-22 black-085 w-400" />
            </div>}
        </div>
        <Paragraph className="monthly-period manrope f-14 lh-22 w-400 black-085">{bundle.image_length}</Paragraph>

        <Button type="primary"
          className={`card-button`}
          block
          onClick={() => openPaymentConfirmationModal(bundle.name, 'bundle', quantity[bundle.title] || 1)}
        >
          {bundle.name != "pdp_pro" ? <span>
            {bundle.buttonText} {quantity[bundle.title] * bundle.credit_multiplier} credits
          </span> : <span>{bundle.buttonText}</span>}
        </Button>
      </div>

      <div className="features-wrapper">
        {/* Desktop view */}
        <div className="desktop-features md:block">
          <div className="features">
            <span className="features-heading manrope f-14 w-700">Includes</span>
            {renderFeatures}

            <span className="features-heading manrope f-14 w-700">Plus</span>
            <div className="features manrope f-14 w-500"><FeatureList features={bundle.plus_features} /> </div>


          </div>
          {bundle.additional_desc ?
            <div className="manrope f-12 w-400 black-085 lh-20">{bundle.additional_desc}</div> : ''}

        </div>

        {/* Mobile view */}
        <div className="mobile-features md:hidden">
          {renderMobileFeatures}
        </div>

      </div>

    </Card >
  );
};

const Plans = ({ openPaymentConfirmationModal, currentlyActiveSubscription, setAnnualSetting }) => {
  const [selectedPlan, setSelectedPlan] = useState("subscriptions");
  const [annual, setAnnual] = useState(true);

  return (
    <div className="pricing-plans-wrapper">
      <div className="pricing-plans">

        <SubscriptionSelector
          selectedPlan={selectedPlan}
          setSelectedPlan={setSelectedPlan}
          annual={annual}
          setAnnual={setAnnual}
          setAnnualSetting={setAnnualSetting}
        />

        {selectedPlan === "subscriptions" ? (
          <>
            <Row gutter={[16, 16]} style={{ display: 'flex', justifyContent: 'space-evenly' }}>
              {plans.map((plan, index) => (
                <PlanCard
                key={index}
                plan={plan}
                index={index}
                openPaymentConfirmationModal={openPaymentConfirmationModal}
                currentlyActiveSubscription={currentlyActiveSubscription}
                annual={annual} />
              ))}
            </Row>
            <Paragraph className="footnote manrope f-14 black-085 w-500 lh-22">
              All subscriptions are an annual contract regardless of payment schedule. You may unsubscribe at any time with a 30 day notice.{" "}
              <a href="#faqs" className="footnote-link manrope f-14 w-700">See FAQs</a>
            </Paragraph>
          </>
        ) : (
          <>
            <Row gutter={[16, 16]} style={{ display: 'flex', justifyContent: 'space-evenly' }}>
              {bundles.map((bundle, index) => (
                <Col xs={24} sm={12} md={12} lg={8} key={index} className="halo-outline transparent pdt-36">
                  <BundleCard
                  key={index}
                  bundle={bundle}
                  index={index}
                  openPaymentConfirmationModal={openPaymentConfirmationModal}
                   />
                </Col>
              ))}
            </Row>
            <Row gutter={[16, 16]} className="show-mid-screen">
              {bundles.map((bundle, index) => (
                <Col xs={24} sm={12} md={12} lg={8} key={index} className="halo-outline transparent pdt-36">
                  <BundleCard
                  key={index}
                  bundle={bundle}
                  index={index}
                  openPaymentConfirmationModal={openPaymentConfirmationModal} />
                </Col>
              ))}

            </Row>
            <Paragraph className="footnote manrope f-14 black-085 w-500 lh-22">
              All bundles are a one-time purchase and use a credit system. More credits can be purchased at any time.{" "}
              <a href="#faqs" className="footnote-link manrope f-14 w-700">See FAQs</a>
            </Paragraph>
          </>
        )}
      </div>
    </div>
  );
};

export default Plans;
